module.exports = __webpack_public_path__ + "static/media/hyle.2a8d2d43.mp3";